import { formatCurrency } from "../../utils/helpers";

export const commissionLabel = (labelColors, type) => ({
    id: 'commissionLabel',
    afterDatasetsDraw: (chart) => {
        const ctx = chart.ctx;
        const xAxis = chart.scales['x'];
        const yAxis = chart.scales['y'];
        const datasets = chart.data.datasets;

        ctx.save();

        // Draw vertical lines conditionally based on type
        if (type === 'Commission Rules') {
            ctx.strokeStyle = '#F6F6F6';
            ctx.lineWidth = 1;
            ctx.beginPath();

            datasets.forEach((dataset, datasetIndex) => {
                const meta = chart.getDatasetMeta(datasetIndex);
                if (!meta.hidden) {
                    meta.data.forEach((element, index) => {
                        if (index < meta.data.length - 1) {
                            const x = (element.x + meta.data[index + 1].x) / 2;
                            ctx.moveTo(x, yAxis.top);
                            ctx.lineTo(x, yAxis.bottom);
                        }
                    });
                }
            });

            ctx.stroke();
        }

        // Calculate maximum bar height for 'Commission Rules' type
        let maxBarValue = 0;
        if (type === 'Commission Rules') {
            datasets.forEach(dataset => {
                dataset.data.forEach(value => {
                    if (value > maxBarValue) {
                        maxBarValue = value;
                    }
                });
            });
        }

        // Draw labels, value and background rectangles
        xAxis.ticks.forEach((data, index) => {
            const x = xAxis.getPixelForTick(index);
            const y = xAxis.bottom - 20;
            const { backgroundColor } = labelColors[index];

            // Calculate label width based on type
            const typeLength = type === 'Commission Rules' ? 10 : 4;
            const labelWidth = xAxis.width / xAxis.ticks.length - typeLength;

            // Draw background rectangle
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(x - labelWidth / 2, y, labelWidth, 20);

            // Draw label text
            let labelText = String(data.label);

            // Append '+' to the last label if the percentage value is 200
            if (type === 'Commission Qty Enhancers' && datasets[0].data[index] === 200) {
                labelText += '+';
            }

            ctx.fillStyle = 'white';
            ctx.font = 'bold 11px Montserrat';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(labelText, x, y + 10);

            // Display value above each bar for each dataset
            datasets.forEach((dataset, datasetIndex) => {
                const meta = chart.getDatasetMeta(datasetIndex);
                if (!meta.hidden) {
                    const barValue = dataset.data[index];
                    const barHeight = type === 'Commission Rules' ? maxBarValue : barValue;

                    let valueText = '';

                    if (type === 'Commission Rules') {
                        valueText = `${formatCurrency(barValue)}`;

                        // Draw image above text value
                        const img = new Image();
                        img.src = '../images/icon-dollar-coin.svg';
                        const imgX = x - img.width / 2;
                        const imgY = yAxis.getPixelForValue(maxBarValue) - 30;
                        img.onload = () => {
                            ctx.drawImage(img, imgX, imgY, img.width, img.height);
                        };
                    } else {
                        valueText = `${barValue}%`;
                    }

                    ctx.fillStyle = '#4D5975';
                    ctx.font = 'bold 11px Montserrat';
                    ctx.fillText(valueText, x, yAxis.getPixelForValue(barHeight) - 10);
                }
            });
        });

        ctx.restore();
    }
});
